// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-cell-wrapper[data-v-37a5a1ca] {
  display: flex;
  align-items: center;
  gap: 10px;
}
.status-cell-wrapper__dot[data-v-37a5a1ca] {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
